import { Component, Inject } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MfaService } from 'src/app/services/mfa.service';

export interface MfaCodeDialogData {
  action: 'disable' | 'regenerate';
}

/**
 * DialogMfaCodeComponent asks for the current TOTP code to either disable MFA
 * or regenerate backup codes. For regeneration it shows the new codes inline
 * before closing.
 */
@Component({
  selector: 'app-dialog-mfa-code',
  templateUrl: './dialog-mfa-code.component.html',
  styleUrl: './dialog-mfa-code.component.scss',
})
export class DialogMfaCodeComponent {
  submitting: boolean = false;
  error: string = '';
  backupCodes: string[] = [];
  done: boolean = false;

  codeForm: UntypedFormGroup = new UntypedFormGroup({
    code: new UntypedFormControl('', [
      Validators.required,
      Validators.pattern(/^\d{6}$/),
    ]),
  });

  constructor(
    public dialogRef: MatDialogRef<DialogMfaCodeComponent>,
    private _mfaService: MfaService,
    @Inject(MAT_DIALOG_DATA) public data: MfaCodeDialogData
  ) {}

  submit() {
    if (!this.codeForm.valid) {
      return;
    }
    this.submitting = true;
    this.error = '';
    const code = this.codeForm.get('code')?.value;

    if (this.data.action === 'disable') {
      this._mfaService.mfaDisable(code).subscribe({
        next: (response) => {
          this.submitting = false;
          if (response.success) {
            this.dialogRef.close({ success: true, action: 'disable' });
          } else {
            this.error = 'mfa.codeError';
          }
        },
        error: () => {
          this.submitting = false;
          this.error = 'mfa.codeError';
        },
      });
    } else {
      this._mfaService.regenerateBackupCodes(code).subscribe({
        next: (response) => {
          this.submitting = false;
          if (response.success) {
            this.backupCodes = response.backup_codes;
            this.done = true;
          } else {
            this.error = 'mfa.codeError';
          }
        },
        error: () => {
          this.submitting = false;
          this.error = 'mfa.codeError';
        },
      });
    }
  }

  close() {
    this.dialogRef.close({ success: true, action: 'regenerate' });
  }
}
